import React from "react";
import {connect} from "react-redux";
import {
  Dimensions,
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View
} from "react-native";
import TendancetListItem from "../Tendance/TendancetListItem";
import LexicalSectionList from "../LexicalSectionList/LexicalSectionList";
import BarreRecherche from "../Header/BarreRecherche";
import {getAllContact, searchEntity, searchContact} from "../../API/API";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {wrapAction, wrapStyle} from "../../sw/helpers";
import CheckActivePicto from "../Picto/CheckActivePicto";
import CheckNotActivePicto from "../Picto/CheckNotActivePicto";


class ExplorerContactList extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      search: this.props.search || "",
      data: [],
      active_display_list: true
    }
    this.search = this.search.bind(this);
  }

  componentDidMount() {
    this._updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.search !== this.state.search ||
      (this.props.search !== undefined && prevProps.search !== this.props.search) ||
      prevProps.data !== this.props.data ||
      prevState.active_display_list !== this.state.active_display_list
    ) {
      this._updateData();
    }
  }

  _updateData = async () => {
    const { search, active_display_list } = this.state;
    if (this.props.search !== undefined) {
      this.setState({search: this.props.search});
    }
    let allData = this.props.data;

    if (this.props.isUpdate && active_display_list !== true) {
      allData = allData.filter((item) => active_display_list.some(x => x.id === item.id));
    }

    let dataToProcess;
    const currentSearch = search;

    if (search === "") {
      dataToProcess = allData;
    } else {
      const result = await this.semantic_search(search, allData);
      // Vérifie que la recherche n'a pas changé pendant l'attente
      if (this.state.search !== currentSearch) return;
      dataToProcess = result.data;
    }

    const formattedData = this._formatDataForSectionList(dataToProcess);
    this.setState({ data: formattedData });
  }

  _formatDataForSectionList(data) {
    const { search } = this.state;
    if (!data || data.length === 0) return [];

    const sortedData = this._sortData(data);
    let firstLetter = search != "" ? null : this._getFirstLetter(sortedData[0]);

    const result = search != "" ? [{ title: null, data: sortedData }] : this._groupDataByFirstLetter(sortedData, firstLetter);

    console.log("result", result);
    return result;
  }

  _getFirstLetter(item) {
    return this.props.isEntity
      ? item.name.charAt(0).toUpperCase()
      : item.lastname.charAt(0).toUpperCase();
  }

  _groupDataByFirstLetter(data, firstLetter) {
    const result = [{ title: firstLetter, data: [] }];

    data.forEach((item) => {
      const itemDescr = this.props.isEntity ? item.name : item.lastname;
      const itemLetter = itemDescr.charAt(0).toUpperCase().replace('É', 'E');

      if (firstLetter !== itemLetter) {
        firstLetter = itemLetter;
        result.push({ title: firstLetter, data: [item] });
      } else {
        const section = result.find(s => s.title === firstLetter);
        section?.data.push(item);
      }
    });

    return result;
  }

  semantic_search(search, data) {
    const parsedSearch = parseAccent(search.toUpperCase());
    if (this.props.isEntity) {
      return searchEntity(parsedSearch, data);
    } else {
      return searchContact(parsedSearch, data);
    }
  }

  _sortData(data){
    return [...data].sort((a, b) => {
      let indexA = (this.props.isEntity ? a.name : a.lastname).replace('É', 'E').toUpperCase();
      let indexB = (this.props.isEntity ? b.name : b.lastname).replace('É', 'E').toUpperCase();
      return indexA.localeCompare(indexB);
    });
  }

  search(text){
    this.setState({ search: text });
    this.props.setSearch && this.props.setSearch(text);
  }

  getDimensions() {
    return Dimensions.get('window');
  }

  renderEmptyContainer(width, height){
    return (<View style={{width:width,height:height,justifyContent:"center",alignItems:"center"}}><Text style={{color:this.props.theme.colors.tertiary.black1.value}}>Aucun élément à afficher</Text></View>)
  }

  renderSelector(styles) {
    const { active_display_list } = this.state;

    const cb = () => {
      if (active_display_list !== true) {
        this.setState({ active_display_list: true });
      } else {
        const { focusList, focusListSet, notificationList, notificationListSet } = this.props;
        this.setState({
          active_display_list: [...focusList, ...focusListSet, ...notificationList, ...notificationListSet]
        });
      }
    };

    return (
      <TouchableOpacity style={styles.containerSelectAll} onPress={wrapAction(cb)}>
        <View>
          {active_display_list === true
            ? <CheckNotActivePicto isHeader={true} style={{width:26,height:26}} />
            : <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
          }
        </View>
        <Text style={styles.selectAllText}>
          {this.props.t('Show active elements only')}
        </Text>
      </TouchableOpacity>
    );
  }

  render(){
    const { width, height } = this.getDimensions();
    const styles = createStyles(this.props.theme);

    const header = (
      <View style={{width:width,alignItems:"center"}}>
        <View style={{width:"90%",height:60,marginHorizontal:10}}>
          <BarreRecherche text={this.state.search} search={this.search} fullScreen={true} />
        </View>
        {this.props.isUpdate && this.renderSelector(styles)}
      </View>
    );

    const {
      focusListSet = [],
      focusListUnSet = [],
      focusList = [],
      notificationListSet = [],
      notificationListUnSet = [],
      notificationList = [],
    } = this.props;

    return (
      <View style={{minWidth:width,marginBottom:(this.props.isFocus) ? 0 : 60 }}>
        <KeyboardAvoidingView style={{flex:1,width:width}} enabled={false} behavior={"height"}>
          <LexicalSectionList
            listHeaderHeight={16}
            style={{marginRight:5,height : height-202,minWidth:width}}
            stickyHeader={false}
            itemHeight={90}
            ListEmptyComponent={this.renderEmptyContainer(width, height)}
            ListHeaderComponent={header}
            renderSectionHeader={({ section: { title } }) => <View style={styles.letterContainer}><Text style={styles.letter}>{title}</Text></View>}
            renderItem={({ item }) => (
              <TendancetListItem
                type={this.props.type}
                setFocusList={this.props.setFocusList}
                isInFocusSetList={focusListSet.some(x=> x.id === item.id)}
                isInFocusUnSetList={focusListUnSet.some(x => x.id === item.id)}
                isFocused={focusList.some(x => x.id === item.id)}
                isInNotificationSetList={notificationListSet.some(x=> x.id === item.id)}
                isInNotificationUnSetList={notificationListUnSet.some(x => x.id === item.id)}
                isNotification={notificationList.some(x => x.id === item.id)}
                setNotificationList={this.props.setNotificationList}
                isUpdate={this.props.isUpdate}
                isFocus={this.props.isFocus}
                key={item.id}
                isEntity={this.props.isEntity}
                refNavigation={this.props.refNavigation}
                hideArticle={true}
                isExplorer={this.props.isExplorer}
                avatar={true}
                item={item}
              />
            )}
            alphabetListOptions={{
              itemHeight:18,
              indicatorTextStyle: {fontFamily:this.props.theme.fonts.title,color:this.props.theme.colors.tertiary.value},
              indicatorStyle:{backgroundColor :this.props.theme.colors.primary.blue1.value },
              itemStyle:{fontSize :13,fontFamily:this.props.theme.fonts.text,color : this.props.theme.colors.primary.blue1.value},
              containerStyle:{marginTop:-100,marginRight:0,padding:7}
            }}
            // On utilise directement this.state.data qui est toujours à jour
            sections={this.state.data}
          />
        </KeyboardAvoidingView>
      </View>
    );
  }
}

function parseAccent(e){
  if(e===null)return null;
  return e.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const createStyles = (theme) => StyleSheet.create({
  letterContainer :{
    marginLeft:26,
    marginTop:8,
    marginBottom:20
  },
  letter :{
    fontFamily:theme.fonts.title,
    fontWeight:"600",
    fontSize:15,
    color:theme.colors.tertiary.black1.value
  },
  menuLetter:{
    fontFamily:theme.fonts.text,
    color : theme.colors.primary.blue1.value,
    fontWeight:"600",
    fontSize:11,
  },
  selectAllText : {
    color : theme.colors.primary.blue1.value,
    fontFamily: theme.fonts.text,
    marginLeft: 5
  },
  containerSelectAll : wrapStyle({
    borderTopWidth:1,
    borderBottomWidth:1,
    borderColor:theme.colors.tertiary.black13.value,
    flexDirection:"row",
    alignItems:"center",
    marginVertical:10,
    paddingVertical:10,
    marginHorizontal:20
  })
});


const mapStateToProps = (state) => {
  return {
    isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
    online: state.sw_reducer.online
  };
}

export default compose(withTranslation(),connect(mapStateToProps))(ExplorerContactList);
